export enum CashDeskMode
{
    Production = 1,
    Training = 2,
    Test = 3
}